import React, {useCallback, useEffect} from "react"
import {Modal} from "../Modals/Modal"

interface WebauthnRegisterModalProps {
	closeModal: () => void
	onSuccess: () => void
	eventHandler: (e: any) => void
}

type WebauthnFinishRegisterSuccess = {
	value: {
		data: {
			attributes: {
				username: string
				isSuccess: boolean
			}
		}
	}
}

type WebauthnFinishRegisterError = {
	error: {
		errors: {
			title: string
			status: string
		}[]
	}
}

export type WebauthnRegisterFinishResponse = {
	detail: WebauthnFinishRegisterSuccess | WebauthnFinishRegisterError
}

export function WebauthnRegisterModal({closeModal, onSuccess, eventHandler}: WebauthnRegisterModalProps) {
	const refreshAndClose = useCallback(() => {
		onSuccess()
		closeModal()
	}, [onSuccess, closeModal])

	useEffect(() => {
		document
			.querySelector("unit-elements-webauthn-register")
			?.addEventListener("unitWebauthnRegisterFinished", (e) => eventHandler(e))
	}, [])

	return (
		<Modal close={refreshAndClose} enableClickAway={false} blockBodyScroll={true} classname="webauthn-mfa-modal">
			<unit-elements-webauthn-register />
		</Modal>
	)
}
